import React from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { GeneraExcel_v1 } from './GeneraExcel_v1'

const RiepilogoQuestionario = () => {
  const questCorrente = useSelector(
    (state) => state.questCorrente
  );
  
  const handleDownload = () => {
    GeneraExcel_v1 (questCorrente)
  };

  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <Card.Title style={{marginBottom:"3%"}}>
          <h4 className="text-center">
            <strong>Riepilogo dei dati in input</strong>
          </h4>
        </Card.Title>
        <Card.Text>

          <div>
            <button onClick={handleDownload}>Esporta file .xlsx con riepilogo dati in input</button>
          </div>

        </Card.Text>
      </Card.Body>
    </Card>
  )

};

export default RiepilogoQuestionario;

/*
  // VISUALIZZAZIONE DEI CRITERI DI CALCOLO CON TESTO A CAPO:

  import { TextWithLineBreaks } from '../components-csvc/TextWithLineBreaks'
  <td align="left"><TextWithLineBreaks text={kpi.perCorrGiust} /></td>
  
          <div>
            <button onClick={handleDownload}>Esporta file .xlsx con riepilogo dati in input</button>
          </div>

          <hr/>

          <div>
            <button onClick={handleDownloadFileExcelModificato}>Scarica File Excel Modificato</button>
          </div>
*/
